import { useConversations } from '@staff/ui'

import { getStoredToken } from '@/services/auth'

export const useMicroscopeConversations = () =>
  useConversations({
    apiUrl: `${import.meta.env.VITE_APP_API_URL}/borgo/distributor`,
    getToken: () => getStoredToken()?.jwt,
  })
